import * as React from "react";

const MyListIcon: React.FC = () => {
    return (
        <svg width={40} height={41} viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_22455_9731)">
                <path
                    d="M23.332 17.152h-20v3.333h20v-3.333zm0-6.667h-20v3.333h20v-3.333zm-20 16.667h13.333v-3.334H3.332v3.334zm32.5-7.5l2.5 2.5-11.65 11.666-7.517-7.5 2.5-2.5 5.017 5 9.15-9.166z"
                    fill="#0C0C0C"
                />
            </g>
            <defs>
                <clipPath id="clip0_22455_9731">
                    <path fill="#fff" transform="translate(0 .485)" d="M0 0H40V40H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(MyListIcon);
